import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useAction } from 'hooks';
import Account from 'modules/Account';
import DownloadDataModal from './DownloadDataModal';
import Initializing from './DownloadDataModal/Initializing';
import Connect from './DownloadDataModal/Connect';
import ConnectionFailed from './DownloadDataModal/ConnectionFailed';
import Downloading from './DownloadDataModal/Downloading';
import Timeout from './DownloadDataModal/Timeout';
import DownloadSummary from './DownloadDataModal/DownloadSummary';
const components = {
    Initializing,
    Connect,
    ConnectionFailed,
    Downloading,
    Timeout,
    DownloadSummary
};
const PwdDownloadDataModal = ()=>{
    const connectorType = 'MDA';
    const defaultComponentName = 'Initializing';
    const fetchSupportedDevices = useAction(Account.actions.fetchPatientProfileSupportedDevices);
    useEffect(()=>{
        fetchSupportedDevices();
    }, []);
    return /*#__PURE__*/ _jsx(DownloadDataModal, {
        connectorType: connectorType,
        components: components,
        defaultComponentName: defaultComponentName
    });
};
export default PwdDownloadDataModal;
